export default __webpack_public_path__ + "static/media/logo_coca_cola.20594a03.png";